import React, {useEffect, useState} from 'react'
import {Formik, Field} from 'formik'
import {Form} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
import {useAuth} from '../../../auth'
import {toast} from 'react-toastify'
import {getNotifications, updateSecurityCompilance} from '../../core/_requests'
import {Loader} from '../../../widgets/components/General/Loader'

const Notifications = () => {
  const {formatMessage} = useIntl()
  const {companyId} = useAuth()
  const {recordId} = useParams()
  const [notificationData, setNotificationData] = useState<any>()
  const [loading, setLoading] = useState(false)
  const initialValues = {
    fileModification: notificationData?.fileModification || false,
    fileSharing: notificationData?.fileSharing || false,
    versionChanges: notificationData?.versionChanges || false,
    accessRequest: notificationData?.accessRequest || false,
    legalHoldUpdate: notificationData?.legalHoldUpdate || false,
    retentionPolicyUpdates: notificationData?.retentionPolicyUpdates || false,
  }

  const getAllNotifications = async (recordId: string) => {
    if (!companyId || !recordId) return
    try {
      setLoading(true)
      const {
        data: {data, success, errors},
      } = await getNotifications(companyId, recordId)
      if (success) {
        setNotificationData(data?.getDetails)
      } else {
        toast.error(errors[0])
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (recordId) getAllNotifications(recordId)
  }, [recordId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = async (values: any) => {
    if (!companyId || !recordId) return
    const payload = {
      fileModification: values?.fileModification,
      fileSharing: values?.fileSharing,
      versionChanges: values?.versionChanges,
      accessRequest: values?.accessRequest,
      legalHoldUpdate: values?.legalHoldUpdate,
      retentionPolicyUpdates: values?.retentionPolicyUpdates,
    }
    try {
      const {
        data: {success, errors},
      } = await updateSecurityCompilance(companyId, recordId, payload)
      if (success) {
        toast.success('Notifications updated successfully')
      } else {
        toast.error(errors[0])
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div className='p-4 bg-white rounded'>
      <h1 className='font-size-16'>{formatMessage({id: 'Notifications'})}</h1>
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <div className='mt-4'>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            validateOnMount
          >
            {(formik) => {
              return (
                <Form>
                  {[
                    {
                      id: 'File Modification',
                      tooltip: 'Get notified when any changes are made to this file.',
                      name: 'fileModification',
                    },
                    {
                      id: 'File Sharing',
                      tooltip: 'Receive notifications when this file is shared with others',
                      name: 'fileSharing',
                    },
                    {
                      id: 'Version Changes',
                      tooltip: 'Get updates when a new version of this file is released',
                      name: 'versionChanges',
                    },
                    {
                      id: 'Access Requests',
                      tooltip: 'Notify me if someone requests access to this file',
                      name: 'accessRequest',
                    },
                    {
                      id: 'Legal Hold Update',
                      tooltip: 'Alert me when this file is placed under a legal hold',
                      name: 'legalHoldUpdate',
                    },
                    {
                      id: 'Retention Policy Updates',
                      tooltip: 'Get notifications when the retention policy for this file changes',
                      name: 'retentionPolicyUpdates',
                    },
                  ].map(({id, tooltip, name}) => (
                    <div
                      key={name}
                      className='form-check form-check-custom form-check-solid form-check-primary form-switch my-2'
                    >
                      <label className='togglebtn mx-0'>
                        <Field
                          className='togglebtn__input'
                          name={name}
                          type='checkbox'
                          formik={formik}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            formik.setFieldValue(name, event.target.checked)
                            formik.submitForm()
                          }}
                        />
                        <div className='togglebtn__fill'></div>
                      </label>
                      <div className='d-flex flex-column justify-content-end mt-2'>
                        <div className='d-flex'>
                          <div>
                            <label
                              className='form-check-label fw-semibold font-size-13 title-notification'
                              data-bs-toggle='tooltip'
                            >
                              {formatMessage({id})}
                            </label>
                          </div>
                        </div>
                        <label
                          className='form-check-label text-clr58 fw-normal fs-7'
                          data-bs-toggle='tooltip'
                        >
                          {formatMessage({id: tooltip})}
                        </label>
                      </div>
                    </div>
                  ))}
                </Form>
              )
            }}
          </Formik>
        </div>
      )}
    </div>
  )
}

export default Notifications
